import LandForm from '@/views/publish-project/project-info/land-form/land-form.vue'; // 耕地
import WoodsForm from '@/views/publish-project/project-info/woods-form/woods-form.vue'; // 林地
import WaterForm from '@/views/publish-project/project-info/water-form/water-form.vue'; // 水面
import SihuangForm from '@/views/publish-project/project-info/sihuang-form/sihuang-form.vue'; // 四荒
import HouseForm from '@/views/publish-project/project-info/house-form/house-form.vue';
import FacilityForm from '@/views/publish-project/project-info/facility-form/facility-form.vue'; // 设备设施
import OtherForm from '@/views/publish-project/project-info/other-form/other-form.vue';
import synthesizeForm from '@/views/publish-project/project-info/synthesize-form/synthesize-form.vue'; // 综合类

import Service from '@/service/index.js';
import AssetsService from '../service.js';

export default {
  components: {
    LandForm,
    WoodsForm,
    OtherForm,
    WaterForm,
    SihuangForm,
    FacilityForm,
    HouseForm,
    synthesizeForm
  },
  data() {
    return {
      ruleForm: {
        projectType: '1',
        projectSubType: '1',
        bidGeneralSituation: []
      },
      rules: {
        projectType: [
          { required: true, message: '请选择项目类型', trigger: 'change' }
        ],
        projectSubType: [
          { required: true, message: '请选择项目分类', trigger: 'change' }
        ],
        bidGeneralSituation: [
          { required: true, message: '请选择标的概况', trigger: 'change' }
        ]
      },
      projectTypeArr: [],
      projectSubTypeArr: {},
      bidGeneralSituationArr: [],
      test: null,
      projectInfo: {},
      landTotalForm: {}
    };
  },
  watch: {
    // 标的情况
    'ruleForm.bidGeneralSituation': function(value) {
      Bus.$emit('bidGeneralSituationChange', value);
    }
  },
  created () {
    Service.getSelectList('PROJECT_TYPE').then(({ code, data }) => {
      if (code === '0') {
        this.projectTypeArr = data;
        this.projectSubTypeArr = this.projectTypeArr.find(item => item.code === this.ruleForm.projectType);
      }
    });

    Service.getSelectList('BID_GENERAL_SITUATION').then(({ code, data }) => {
      if (code === '0') {
        this.bidGeneralSituationArr = data;
      }
    });
  },
  methods: {
    onLandTotalForm (event) {
      this.landTotalForm = event;
    },
    // 获取项目子类集合
    selectChanged(val) {
      this.projectSubTypeArr = {};
      this.projectTypeArr.forEach(item => {
        if(item.code === val) {
          this.projectSubTypeArr = item;
        }
      });
    },
    previousStep () {
      this.$router.back();
    },
    submit () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let formList = ['landForm', 'woodsForm', 'waterForm', 'sihuangForm', 'houseForm', 'facilityForm', 'synthesizeForm'];
          formList.forEach(item => {
            if(this.$refs[item]?.test()) {
              this.test = this.$refs[item].test();
            }
          });
          this.test.then((res) => {
            let params = {
              ...res,
              ...this.ruleForm
            };
            params.assetsInfo = JSON.stringify(params.massifs);
            delete params.massifs;
            console.log(params, '====params');
            AssetsService.assetsSave(params).then(res => {
              if(res.code === '0'){
                this.$successMessage('资产添加成功');
                this.$router.push({path: '/person-center/my-assets/list'});
              }
            }).catch(error => {
              console.log(error, '===error');
            });
          });
        }
      });
    }
  }
};
